// extracted by mini-css-extract-plugin
module.exports = {"image":"lazycover_image__2-4bm","source":"lazycover_source__3S0zN","preloader":"lazycover_preloader__DUtS4"};